import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { UsuarioDto } from '../dto/usuario/usuario.dto';
import { TiposUsuarioResponseDto } from '../dto/usuario/tipo-usuario.dto';
import { ValidarUsuarioResponseDto } from '../dto/auth/validar-usuario.response.dto';
import { Observable } from 'rxjs';
import { UsuarioPersonaDto } from '../dto/usuario/usuario-persona.dto';

@Injectable({
  providedIn: 'root',
})
export class UsuarioService {
  private apiUrl = `${environment.apiUrl}/usuario`;

  constructor(private http: HttpClient) {}

  crearUsuario(usuarioDto: UsuarioDto) {
    return this.http.post<any>(`${this.apiUrl}/crear`, usuarioDto);
  }

  consultarTiposUsuario(usuarioId: number, idioma?: string): Observable<TiposUsuarioResponseDto> {
    const params: { idioma?: string } = idioma ? { idioma } : {};

    return this.http.get<TiposUsuarioResponseDto>(
      `${this.apiUrl}/tipo-usuario/${usuarioId}`,
      { params }
    );
  }

  validarUsuario(
    email: string,
    token: string
  ): Observable<ValidarUsuarioResponseDto> {
    const params = { email, token };
    return this.http.get<ValidarUsuarioResponseDto>(
      `${this.apiUrl}/validarusuario`,
      { params }
    );
  }
}
